import ProcessFlowVariables from "~/components/dynamicFieldsTrees/handlerComponents/process-flow-variables-fields.vue";
import FormFieldData from "~/components/dynamicFieldsTrees/handlerComponents/form-field-data.vue";
import ObjectModelPropertyData from "~/components/dynamicFieldsTrees/handlerComponents/object-model-property-data.vue";
import ObjectModelRelationshipData from '~/components/dynamicFieldsTrees/handlerComponents/object-model-relationship-data.vue';
import ObjectModelAccountRelationData from '~/components/dynamicFieldsTrees/handlerComponents/object-model-account-relation-data.vue';
import FormSubmitterData from "~/components/dynamicFieldsTrees/handlerComponents/form-submitter-data.vue";
import DateFields from "~/components/dynamicFieldsTrees/handlerComponents/date-fields.vue";
import ProcessFlowFormDynamicFields from '../../../../formability/processFlowBuilder/components/form-submission-dynamic-fields.vue';
import ProcessFlowObjectModelDynamicFields from '../../../../formability/processFlowBuilder/components/object-model-dynamic-fields.vue';
import ProcessFlowApiEndPointDynamicFields from '../../../../formability/processFlowBuilder/components/api-end-point-dynamic-fields.vue';
import ProcessFlowFormElementDynamicFields from '../../../../formability/processFlowBuilder/components/process-flow-form-element-dynamic-fields.vue';
import SubObjectFields from "../../../../formability/processFlowBuilder/components/sub-object-fields.vue";
import ObjectModelAccountRelations from "../../../../formability/object_model_builder/components/account-relations-dynamic-fields.vue";
import ProcessFlowMetadata from "~/components/dynamicFieldsTrees/handlerComponents/process-flow-metadata.vue";
import CertificateDynamicInputs from "~/components/dynamicFieldsTrees/handlerComponents/certificate-dynamic-inputs.vue";

export default {
  components: {
    ProcessFlowVariables,
    FormFieldData,
    ObjectModelPropertyData,
    ObjectModelRelationshipData,
    FormSubmitterData,
    DateFields,
    ProcessFlowFormDynamicFields,
    ProcessFlowObjectModelDynamicFields,
    ProcessFlowFormElementDynamicFields,
    ProcessFlowApiEndPointDynamicFields,
    SubObjectFields,
    ObjectModelAccountRelations,
    ObjectModelAccountRelationData,
    ProcessFlowMetadata,
    CertificateDynamicInputs,
  },
}